import React, { useState } from "react";
import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/pro-regular-svg-icons/faSave";

const HubspotFormForm = ({
    onChange,
    state: { formSettings = { portalId: "", formId: "", region: "na1" } },
}) => {
    const [internalFormSettings, setInternalFormSettings] = useState({
        portalId: formSettings.portalId || "",
        formId: formSettings.formId || "",
        region: formSettings.region || "na1",
    });

    return (
        <>
            <TextInput
                label="Portal ID"
                value={internalFormSettings.portalId}
                onChange={(e) =>
                    setInternalFormSettings({
                        ...internalFormSettings,
                        portalId: e.target.value,
                    })
                }
            />
            <TextInput
                label="Form ID"
                value={internalFormSettings.formId}
                onChange={(e) =>
                    setInternalFormSettings({
                        ...internalFormSettings,
                        formId: e.target.value,
                    })
                }
            />
            <TextInput
                label="Region"
                value={internalFormSettings.region || "na1"}
                onChange={(e) =>
                    setInternalFormSettings({
                        ...internalFormSettings,
                        region: e.target.value || "na1",
                    })
                }
            />
            <button
                className="btn btn-sm btn-success w-100 my-2"
                onClick={(e) => {
                    onChange({
                        formSettings: internalFormSettings,
                    });
                }}
            >
                <FontAwesomeIcon icon={faSave} className="mr-2" /> Set Form
                Settings
            </button>
        </>
    );
};

export default HubspotFormForm;
